// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMINCLUB_MENU = "Adminclub";
export const DELETE_AVATAR = "Zma\u017e profilov\u00fa fotku";
export const TICKETS_TITLE = "tickets";
